import React, {Component} from 'react'

export default class CurrentIssue extends Component {

    render() {
        return (
            <div className="issue issueCurrent">
                <span className="issueNumber">
                    Current issue
                </span>
                <input type="button" className="btn btn-sm btn-primary btn-issue" value="Generate HTML"
                       onClick={ () => this.context.router.push('/current-html') }/>
                <input type="button" className="btn btn-sm btn-success btn-issue" value="Create"
                       onClick={ () => {
                           this.props.createIssue().then(this.props.refreshDashboard)
                       } }/>
            </div>
        )
    }

}

CurrentIssue.contextTypes = {
    router: React.PropTypes.object
};



// WEBPACK FOOTER //
// ./src/dashboard/archive/CurrentIssue.js